import React from "react";
import { targetDevices } from "config/devices";
import SelectList, { SelectListItem } from "playground/ui/SelectList";

//import PropTypes from 'prop-types';

export function DeviceSelectList(props) {
    const { onMenuClose, onChange, value } = props;
    return (
        <SelectList onClick={onMenuClose}>
            {Object.keys(targetDevices).map((device) => (
                <SelectListItem
                    key={device}
                    onClick={(e) => onChange(e, device)}
                >
                    {targetDevices[device]}
                </SelectListItem>
            ))}
        </SelectList>
    );
}

DeviceSelectList.propTypes = {};

DeviceSelectList.defaultProps = {};

export default DeviceSelectList;
